import * as Phaser from 'phaser';
import { SCENES } from '@/types';
import { GAME_HEIGHT, GAME_WIDTH } from '@/config/gameConfig';
import { generateAllTextures } from '@/utils/textures';

const BAR_WIDTH = 220;
const BAR_HEIGHT = 14;
const BAR_RADIUS = 7;
const FAKE_LOAD_MS = 600;

export class PreloadScene extends Phaser.Scene {
  constructor() {
    super(SCENES.Preload);
  }

  create(): void {
    const cx = GAME_WIDTH / 2;
    const cy = GAME_HEIGHT / 2;

    this.add
      .text(cx, cy - 80, 'Voi Lớn Lên', {
        fontFamily: 'Inter, system-ui, sans-serif',
        fontSize: '28px',
        fontStyle: 'bold',
        color: '#ffffff',
      })
      .setOrigin(0.5)
      .setShadow(0, 2, '#0006', 4, true, true);

    this.add
      .text(cx, cy - 50, 'Đang chuẩn bị…', {
        fontFamily: 'Inter, system-ui, sans-serif',
        fontSize: '14px',
        color: '#f5f5f5',
      })
      .setOrigin(0.5);

    const barX = cx - BAR_WIDTH / 2;
    const barY = cy - BAR_HEIGHT / 2;
    const frame = this.add.graphics();
    frame.lineStyle(2, 0xffffff, 1);
    frame.strokeRoundedRect(barX - 2, barY - 2, BAR_WIDTH + 4, BAR_HEIGHT + 4, BAR_RADIUS + 2);

    const fill = this.add.graphics();
    const percentLabel = this.add
      .text(cx, cy + 22, '0%', {
        fontFamily: 'Inter, system-ui, sans-serif',
        fontSize: '12px',
        color: '#ffffff',
      })
      .setOrigin(0.5);

    generateAllTextures(this);

    const progressState = { value: 0 };
    this.tweens.add({
      targets: progressState,
      value: 1,
      duration: FAKE_LOAD_MS,
      ease: 'Sine.easeInOut',
      onUpdate: () => {
        fill.clear();
        fill.fillStyle(0x3b9f4a, 1);
        fill.fillRoundedRect(barX, barY, BAR_WIDTH * progressState.value, BAR_HEIGHT, BAR_RADIUS);
        percentLabel.setText(`${Math.round(progressState.value * 100)}%`);
      },
      onComplete: () => {
        this.scene.start(SCENES.Intro);
      },
    });
  }
}
